// types
import { Const } from "../../../src/const";
import { SettingsActionTypes, SettingsState } from "./types";

export const INIT_STATE: SettingsState = {
  settings: {},
  orgDllValueForPerm: null,
  activeTool: null,
};

const Settings = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case SettingsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SettingsActionTypes.GET_USER_SETTINGS:
          return {
            ...state,
            settings: action.payload.data,
            isSettingsFetched: true,
            getSettingsLoading: false,
            isSettingsUpdated: false,
          };
        case SettingsActionTypes.UPDATE_USER_SETTINGS:
          return {
            ...state,
            isSettingsUpdated: true,
          };
        case SettingsActionTypes.UC_LOAD_USER_CONFIG: {
          return {
            ...state,
            ucLoadUserConfigLoading: false,
            userConfig: action.payload.data
          }
        }
        default:
          return { ...state };
      }

    case SettingsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SettingsActionTypes.GET_USER_SETTINGS:
          return {
            ...state,
            isSettingsFetched: false,
            getSettingsLoading: false,
          };
        case SettingsActionTypes.UPDATE_USER_SETTINGS:
          return {
            ...state,
            isSettingsUpdated: false,
          };
        case SettingsActionTypes.UC_LOAD_USER_CONFIG: {
          return {
            ...state,
            ucLoadUserConfigLoading: false
          }
        }
        default:
          return { ...state };
      }

    case SettingsActionTypes.SET_ORG_DDL_VALUE_FOR_PERM: {
      return {
        ...state,
        orgDllValueForPerm: action.payload.data
      }
    }

    case SettingsActionTypes.GET_USER_SETTINGS: {
      return {
        ...state,
        getSettingsLoading: true,
        isSettingsFetched: false,
      };
    }
    case SettingsActionTypes.UPDATE_USER_SETTINGS:
      return {
        ...state,
        isSettingsUpdated: false,
      };

    case SettingsActionTypes.UC_LOAD_USER_CONFIG: {
      return {
        ...state,
        ucLoadUserConfigLoading: true
      }
    }

    case SettingsActionTypes.UC_SET_CONFIG_VALUE: {
      const { configKey, configValue } = action.payload;
      const st: any = state;
      return {
        ...st,
        userConfig: {
          ...st.userConfig,
          pushFromChat: configKey == Const.UC_PUSH_FROM_CHAT ? configValue : st.userConfig?.pushFromChat,
          pushFromWp: configKey == Const.UC_PUSH_FROM_WP ? configValue : st.userConfig?.pushFromWp,
        }
      }
    }


    case SettingsActionTypes.SET_ACTIVE_TOOL: {
      const { tool } = action.paylload;
      // console.log('SET_ACTIVE_TOOL = ' + tool);
      return {
        ...state,
        activeTool: tool
      }
    }

    default:
      return { ...state };
  }
};

export default Settings;
